import { TableFilterHint } from "./TableFilterHint.js";
import { TableSortHint } from "./TableSortHint.js";
import { FiltersLine } from "./local-components/FiltersLine/FiltersLine.js";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/TableFiltersLine/TableFiltersLine.tsx
const TableFiltersLine = ({ className, onClear, filterItems, api, sort }) => {
	if (!api) return null;
	return (sort || filterItems.length > 0) && /* @__PURE__ */ jsxs(FiltersLine, {
		onClear: () => {
			api.resetColumnState();
			api.setFilterModel(null);
			onClear?.();
		},
		className,
		children: [sort ? /* @__PURE__ */ jsx(TableSortHint, {
			api,
			sort
		}, `${sort.column}_sort`) : null, filterItems.map((item) => /* @__PURE__ */ jsx(TableFilterHint, {
			api,
			filterItem: item
		}, `${item.column}_filter`))]
	});
};
//#endregion
export { TableFiltersLine };

//# sourceMappingURL=TableFiltersLine.js.map